module.exports = __webpack_public_path__ + "static/media/ks_testtube2.3add73f4.svg";